// extracted by mini-css-extract-plugin
export var sectionWrap = "styles-module--sectionWrap--2ekh8";
export var video = "styles-module--video--1pM1m";